import { render } from "./j-skeleton.vue?vue&type=template&id=9ad72612&scoped=true"
import script from "./j-skeleton.vue?vue&type=script&lang=js"
export * from "./j-skeleton.vue?vue&type=script&lang=js"

import "./j-skeleton.vue?vue&type=style&index=0&id=9ad72612&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad72612"]])

export default __exports__